(function () {
  'use strict';

  angular.module('clientDashboardApp.admin.accounts.groups.groupEditor',
    [
      'clientDashboardApp.admin.groups.groupsService'
    ]).controller("GroupEditorCtrl", GroupEditorCtrl);

  GroupEditorCtrl.$inject = ['accountId', '$log', '$location', 'groupsService', 'pageInfo','$stateParams','stringService','updateService'];

  function GroupEditorCtrl(accountId, $log, $location, groupsService, pageInfo, $stateParams, stringService, updateService ) {
    var vm = this;

    vm.mode = pageInfo.mode;

    vm.accountConfig = {
      required : true,
      accountId : null,
      disableDropdown: vm.mode == "edit",
      showAccountSelection: true,
      editPage: true
    }

    if(vm.mode == "create"){
      vm.accountConfig.accountId = accountId;
    }
    else{
      vm.accountConfig.accountId = $stateParams.accountId;
    }

    vm.defaultGroup = function() {
      return {groupName: ''}
    };

    vm.errorMsg = '';

    vm.pageStrings = stringService.adminStrings(vm.mode);

    vm.createEditGroup = function (formIsValid) {
      vm.state = "PendingConfirmation";
      vm.pendingResponse = true;
      vm.formSubmitted = true;
      if(!formIsValid){
        vm.errorMsg = 'The form is missing some data!';
        return;
      }
      if(vm.mode == "create"){
        groupsService.createGroup(vm.accountConfig.accountId, vm.group.groupName).then(handleCreatedGroup, handleGroupCreationError);
      }
      else{
        groupsService.updateGroup(vm.group).then(handleCreatedGroup, handleGroupCreationError);
      }
    };

    vm.cancel = function(){
      $location.path("admin/v2/groups");
    }

    vm.processSuccessfulAddGroup = function(response){
      vm.newGroup = response.data;
      vm.state = 'Success';
      var updateInfo = {
        status: "Active",
        type: "group",
        title: "Group",
        destinationRole: "manage",
        notificationType: "detail",
        actions: [{action:vm.mode}],
        id: vm.newGroup.id,
        name: vm.newGroup.groupName,
        searchParam: vm.newGroup.groupName
      }
      updateService.registerSuccessfulUpdate(updateInfo);
      $location.path('/admin/v2/groups');
    }

    function handleCreatedGroup(resp) {
      vm.processSuccessfulAddGroup(resp);
      vm.state = 'Success';
    }

    function handleGroupCreationError(resp) {
      vm.state = 'GroupEditing';
      $log.error(resp);
      vm.pendingResponse = false;
      vm.errorMsg = 'An error occurred while creating this group!';
    }

    vm.hasError = function (input) {
      if (!input) return;
      return input.$invalid && (!input.$pristine || vm.formSubmitted);
    };

    activate();

    function activate() {
      vm.state = 'Loading';
      if(vm.mode == "create"){
        vm.state = 'GroupEditing';
        vm.group = vm.defaultGroup();
      }
      else{
        groupsService.getGroup($stateParams.groupId).then(function (resp) {
          vm.state = 'GroupEditing';
          vm.group = resp.data;
          vm.accountConfig.accountId = vm.group.accountId;
        });
      }
      //No activation required
    }

  }
})();
